import React from 'react';

function getCertifictionStatus(certificationStatus) {
  if (certificationStatus !== null) {
    if (certificationStatus === 0) {
      return 'Uncertified';
    }

    const statuses = [];
    const expiredStatuses = [];
    /* eslint-disable no-bitwise */
    const isFatca = (certificationStatus & 1) === 1;
    const isChapter61 = (certificationStatus & 2) === 2;
    const isNra = isFatca && (certificationStatus & 4) === 4;
    const isCrs = (certificationStatus & 8) === 8;
    const isCarf = (certificationStatus & 32) === 32; // 0x20

    const isFatcaExpired = (certificationStatus & 0x1000) === 0x1000;
    const isNraExpired = isFatcaExpired || (certificationStatus & 0x4000) === 0x4000;
    const isCrsExpired = (certificationStatus & 0x8000) === 0x8000;
    const isCarfExpired = (certificationStatus & 0x2000) === 0x2000;
    /* eslint-enable no-bitwise */

    if (isNra) { (isNraExpired ? expiredStatuses : statuses).push('NRA'); }
    if (isFatca) { (isFatcaExpired ? expiredStatuses : statuses).push('FATCA'); }
    if (isChapter61) { (isFatcaExpired ? expiredStatuses : statuses).push('Chapter\u00a061'); }
    if (isCrs) { (isCrsExpired ? expiredStatuses : statuses).push('CRS'); }
    if (isCarf) { (isCarfExpired ? expiredStatuses : statuses).push('CARF'); }

    const activeStatus = statuses.length > 0 ? `Certified: ${ statuses.reduce((prev, curr) => `${ prev }, ${ curr }`) }` : '';
    const expiredStatus = expiredStatuses.length > 0 ? `Expired: ${ expiredStatuses.reduce((prev, curr) => `${ prev }, ${ curr }`) }` : '';
    return <React.Fragment>{ activeStatus }{ activeStatus && expiredStatus && <br /> }{ expiredStatus }</React.Fragment>;
  }

  return null;
}

export default getCertifictionStatus;
